<template>
  <div class="no-data"
       :style="noStyle"
       :class="needBg ? 'need-bg': ''">
    <p>{{noName}}</p>
  </div>
</template>

<script>
// import '@/assets/styles/flexCss/Index.less'
export default {
  name: 'Index',
  props: {
    noData: {
      default: '没有更多了',
      type: String
    },
    noSty: {},
    needBg: {
      default: false,
      type: Boolean
    }
  },
  data () {
    return {
      noName: null,
      noStyle: ''
    }
  },
  watch: {
    noData: {
      handler (val) {
        this.noName = val
      },
      deep: true,
      immediate: true
    },
    noSty: {
      handler (val) {
        this.noStyle = val
      },
      deep: true,
      immediate: true
    },

  }
}
</script>

<style lang="less" scoped>
.no-data {
  padding: 20px;
  color: #666;
  display: flex;
  justify-content: center;
  align-items: center;
  
} 
.need-bg {
  background: url('../../assets/wisdomOffice/no-data.png') no-repeat;
  height: 400px;
  // background-size: 100%;
  background-position: center center;
  position: relative;
  p {
    position: absolute;
    bottom: 100px;
  }
}
</style>